import { render } from "./Stockages.vue?vue&type=template&id=c3cffbcc"
import script from "./Stockages.vue?vue&type=script&lang=js"
export * from "./Stockages.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__